<template>
    
    <v-row>
        <v-col cols="12">
            <TableV nombre="Vehiculos" :table="vehicle" :type="type" :headerss="header" :loadings="loading" />
        </v-col>
    </v-row>
  
</template>
<script>

import Table from '../../../../component/helpers/tools/table'
import Single from '../../../../component/helpers/tools/single'
import TableV from '../../../../component/helpers/tools/tablesearchVehiculo'

export default {
    
    components:{
        Table,
        Single,
        TableV
    },

    data(){
        return {
            type:'vehiculos',
            header: [
                {
                    text: 'Nombre del vehículo',
                    align: 'left',
                    sortable: false,
                    value: 'name',
                },
                { text: 'Placa / Serial', value: 'enrollment' },
                { text: 'Empresa', value: 'enterprise.Nombre'},
                { text: 'Tipo', value: 'type' },
                
                { text: 'Fecha modificación', value: 'updated_at' },
                
            ]

        }
    },

    computed: {
        vehicle(){
            return this.$store.state.vehicle;
        },
        
        loading(){
            return this.$store.state.loading_dashboard
        },

        single(){
            return this.$store.state.select_table
        }

    },


}
</script>